<!-- Large/card discount display-->
<glxy-alert type="info" size="small" *ngIf="size.toLowerCase() === 'large'">
  <strong>Discounts:</strong>
  <span *ngIf="!multipleDiscounts; else multiple">
    {{ discountsFormatted[0] }}
  </span>
  <ng-template #multiple>
    <glxy-alert-extended>
      <div *ngFor="let discount of discountsFormatted">
        {{ discount }}
      </div>
    </glxy-alert-extended>
  </ng-template>
</glxy-alert>
<!-- Small/table/list discount display-->
<div *ngIf="size.toLowerCase() === 'regular'">
  <strong>Active Discounts</strong>
  <span *ngIf="!multipleDiscounts; else multiple">
    {{ discountsFormatted[0] }}
  </span>
  <ng-template #multiple>
    <div *ngFor="let discount of discountsFormatted">
      <li>{{ discount }}</li>
    </div>
  </ng-template>
</div>
